import { apiClient } from "../../../../zodios/client";
import { errorToast } from "../../../../utils/toasts";

type DownloadKind = "errors" | "result";

export async function downloadPricingPlanUploadCsv(uploadId: number, kind: DownloadKind): Promise<void> {
  try {
    const blob =
      kind === "errors" ?
        await apiClient.downloadPricingPlanErrorCsv({ params: { id: uploadId }, responseType: "blob" })
      : await apiClient.downloadPricingPlanResultCsv({ params: { id: uploadId }, responseType: "blob" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `upload-${uploadId}-${kind}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    errorToast({
      title: "Download failed",
      message: "Could not download the CSV. Please try again.",
      error,
    });
  }
}
